import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule, Routes } from '@angular/router';
import { DetailComponent} from './detail/detail.component';
import { FormsModule } from '@angular/forms';
import { WorkgroupService} from './workgroup-services/workgroup.service'
import { WorkgroupProfileComponent } from './profile/workgroup-profile.component';
import { getWorkGroupResolver, getWorkGroupsResolver, getAssociatesResolver} from './workgroup-services/workgroup.resolver';
import { SearchComponent } from './search/search.component'
import { MatSelectModule} from '@angular/material/select';
import { MatDatepickerModule, MAT_DATE_LOCALE, MatInputModule} from '@angular/material'
import { MatAutocompleteModule, MatSnackBar, MatSnackBarModule} from '@angular/material';
import { SharedModule } from '../shared/shared.module';
import { AssociateService } from './../shared/services/associate.service';
import { ApprovalComponent } from './approval/approval.component';
import { ProfileHrComponent } from './profile-hr/profile-hr.component';
import { VisitorComponent } from './visitor/visitor.component';
import { MatPaginatorModule} from '@angular/material/paginator';
import { AuthGuard } from '../shared/services/auth/auth.guard';
import {MatExpansionModule ,MatTooltipModule} from '@angular/material';
import {MatSortModule} from '@angular/material/sort';
import { TextMaskModule } from 'angular2-text-mask';



// // internationalization
import { HttpClient } from '@angular/common/http';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { TranslateService } from '@ngx-translate/core';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';

export function createTranslateLoader(http: HttpClient) {
    return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}

const routes: Routes = [
    { path: '', redirectTo: 'search', pathMatch: 'full' },
    {
        path: 'search',
        component: SearchComponent
    },
    {
        path: 'search/:hr',
        component: SearchComponent,
        resolve: { workGroups: getWorkGroupsResolver },
        },

    {
        path: 'detail', component: DetailComponent,
        resolve: {
        associates: getAssociatesResolver
        },

    },
    {
        path: 'profile/:id', component: WorkgroupProfileComponent,
        resolve: {
            workGroup: getWorkGroupResolver,
            associates: getAssociatesResolver
        },

    },
    {
        path: 'profile-hr/:id', component: ProfileHrComponent,
        resolve: {
        workGroup: getWorkGroupResolver,
        associates: getAssociatesResolver
        },

    }
]

@NgModule({
  imports: [
    CommonModule,
    RouterModule.forChild(routes),
    FormsModule,
    MatSelectModule,
    MatDatepickerModule,
    SharedModule,
    MatAutocompleteModule,
    MatInputModule,
    MatSnackBarModule,
    MatPaginatorModule,
    MatTooltipModule,
    MatExpansionModule,
    MatSortModule,
    MatProgressSpinnerModule,
    TranslateModule.forChild({
        loader: {
            provide: TranslateLoader,
            useFactory: (createTranslateLoader),
            deps: [HttpClient]
        }
    }),
    TextMaskModule,
  ],

  entryComponents: [ ApprovalComponent, VisitorComponent],
  declarations: [DetailComponent, WorkgroupProfileComponent, SearchComponent, ApprovalComponent, ProfileHrComponent, VisitorComponent,],

  providers: [
    WorkgroupService,
    getWorkGroupResolver,
    getWorkGroupsResolver,
    {provide: MAT_DATE_LOCALE, useValue: 'en-GB'},
    AssociateService,
    getAssociatesResolver,
    MatSnackBar
  ]
})
export class WorkGroupsModule {}